import { Fragment } from 'react';
import { Link } from 'react-router-dom';

const {
  ia,
  mString,
  camelToSpaceCase,
  isPrimitiveValue,
  snakeToTitleCase
} = require('lib/helpers/utility');

const nonFormattedFields = ['_id'];

export const generateColumnDefs = (data) => {
  if (!ia(data)) return [];

  const keys = Object.keys(data[0]).filter((key) => key !== 'children');

  const columnDefs = keys.map((key) => {
    const headerName = camelToSpaceCase(
      snakeToTitleCase(key.replace(/__/g, '/').replace(/_id/g, ' #'))
    );

    const isNumber = !isNaN(parseFloat(data[0][key])) && isFinite(data[0][key]);

    const colDef = { headerName, field: key };

    // add group row
    if (keys.indexOf(key) === 0 && data.some((item) => ia(item.children))) {
      colDef.cellRenderer = 'agGroupCellRenderer';
    }

    if (data[0][key]?.value) {
      colDef.valueGetter = (params) => params.data[key]?.value; // this fixes stuffs like sorting in ag grid

      const cellRenderer = (params) => {
        const value = params.data[key]?.value;
        const href = params.data[key]?.href;

        // add link if provided
        if (typeof value !== 'object') {
          if (!href) return value;

          return (
            <Link to={href} target="_blank">
              {value}
            </Link>
          );
        }

        const entries = Object.entries(value || {});

        return (
          <>
            {entries.map(([currentKey, currentValue], index) => {
              if (!href) {
                return (
                  <span key={currentKey}>
                    {!currentKey.endsWith('_') && typeof currentValue === 'number'
                      ? mString(currentValue)
                      : currentValue}
                    {index < entries.length - 1 && ' / '}{' '}
                  </span>
                );
              }

              return (
                <Fragment key={currentKey}>
                  <Link to={href?.[currentKey]} target="_blank">
                    {currentValue}
                  </Link>
                  {index < entries.length - 1 && ' / '}
                </Fragment>
              );
            })}
          </>
        );
      };

      // avoid missing row expanding
      if (!colDef.cellRenderer) {
        colDef.cellRenderer = cellRenderer;
      } else {
        colDef.cellRendererParams = { innerRenderer: cellRenderer };
      }
    }

    if (
      isNumber &&
      !key.endsWith('_') &&
      !nonFormattedFields.some((substring) => key.includes(substring))
    ) {
      colDef.valueFormatter = (params) => {
        return mString(params.value);
      };
    } else if (isPrimitiveValue(data[0][key])) {
      // capitalize values
      colDef.valueFormatter = (params) => {
        return camelToSpaceCase(params?.value?.toString());
      };
    }

    return colDef;
  });

  return columnDefs;
};
